import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getProjectAccess,
  isAdmin,
  isVodexLoggedin,
  LoadingDots,
  PAGE_SIZE_50,
} from "../CommonComponents/Common";
import { lastCampaignActionList } from "../ProjectSection/CampaignSection/Store/Campaign.action";
import {
  getDashboardChartAction,
  getDashboardDataAction,
} from "../Store/Account/Account.action";
import BarChart from "./BarChart";
import CampaignList from "./CampaignList";
import DoughnutChart from "./DoughnutChart";
import Heading from "./Heading";
import SummaryCard from "./SummaryCard";
import "../../../assets/css/page/Dashboard.scss";
import { swalWarningMessage } from "../../../Constant/swalMessage";
import VideoComponentCustom from "../CommonComponents/videomodalCustom";
import PageLoader from "../CommonComponents/PageLoader";
import moment from "moment";

declare global {
  interface Window {
    intercomSettings: {
      api_base: string;
      app_id: string;
      email: string;
      name: string;
    };
  }
}

const DashboardHome = () => {
  const dispatch = useDispatch();
  const {
    AccountReducer: {
      userDetails: { email, firstName, role },
      accountRoles,
      dashboardData,
      chartData,
      selectedAccount,
      userDetails,
    },
    ProjectReducer: { projectList },
    CampaignReducer: {
      campaignRunsList: lastCampaignListData,
      totalCampaignsCount,
    },
  } = useSelector((state: any) => state);
  const showCurr = selectedAccount?.currency === "inr";

  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [state, setState] = useState({
    projectId: "",
    from: "",
    to: "",
  }) as any;

  const [selectedProject, setSelectedProject] = useState(state?.projectId);
  const [filterState, setFilterState] = useState({
    selectedprojectId: state?.projectId,
    dateRange: [
      state?.from ? moment(state?.from).format("YYYY-MM-DD") : null,
      state?.to ? moment(state?.to).format("YYYY-MM-DD") : null,
    ],
  }) as any;

  useEffect(() => {
    if (window.location.origin === "https://app.voizer.ai") {
      // if (window.location.origin === "http://localhost:3000") {
      window.intercomSettings = {
        api_base: "https://api-iam.intercom.io",
        app_id: "rvqfqg0r",
        email: email || "",
        name: firstName || email || "",
      };

      (function () {
        var w: any = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
          ic("reattach_activator");
          ic("update", w.intercomSettings);
        } else {
          var d = document;
          var i: any = function () {
            i.c(arguments);
          };
          i.q = [];
          i.c = function (args) {
            i.q.push(args);
          };
          w.Intercom = i;
          var l = function () {
            var s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/rvqfqg0r";
            var x: any = d.getElementsByTagName("script")[0];
            x.parentNode.insertBefore(s, x);
          };
          if (document.readyState === "complete") {
            l();
          } else if (w.attachEvent) {
            w.attachEvent("onload", l);
          } else {
            w.addEventListener("load", l, false);
          }
        }
      })();
    }

    if (
      Object.keys(dashboardData || {}).length === 0 ||
      Object.keys(chartData || {}).length === 0 ||
      totalCampaignsCount === 0
    ) {
      setLoading(true);
    }
    fetchData(state, 1);
  }, []);

  const fetchData = async (params = state, page = currentPage) => {
    await dispatch(getDashboardDataAction(params));
    setLoading(false);
    await dispatch(getDashboardChartAction(params));

    getCampaigns(params, page);
    setRefreshLoading(false);
  };

  const getCampaigns = async (params, page) => {
    const campaignParams = {
      ...params,
      pageIndex: page,
      pageSize: PAGE_SIZE_50,
    };

    const res: any = await dispatch(lastCampaignActionList(campaignParams));
    const lastCampaigns = res?.[0]?.data;

    if (lastCampaigns?.length > 0) {
      const uniqueProjectIds = Array.from(
        new Set(lastCampaigns?.map((row) => row.projectId))
      );
      for (const projectId of uniqueProjectIds) {
        getProjectAccess(projectId, accountRoles, dispatch);
      }
    }
    setCurrentPage(page);
    setTableLoading(false);
  };

  const applyFilters = () => {
    setFilterState((prev) => ({
      ...prev,
      selectedprojectId: selectedProject || "",
    }));
    const [newStartDate, newEndDate] = filterState?.dateRange;
    if (newStartDate && !newEndDate) {
      swalWarningMessage("Please choose the end date");
      return;
    }
    setLoading(true);
    const updated = {
      projectId: selectedProject,
      from: newStartDate ? moment(newStartDate).format("YYYY-MM-DD") : "",
      to: newEndDate ? moment(newEndDate).format("YYYY-MM-DD") : "",
    };
    setState((prev) => ({
      ...prev,
      ...updated,
    }));
    fetchData(updated, 1);
  };

  const refreshData = () => {
    const [newStartDate, newEndDate] = filterState?.dateRange;
    if (newStartDate && !newEndDate) {
      swalWarningMessage("Please choose the end date");
      return;
    }
    setSelectedProject(filterState?.selectedprojectId);
    setRefreshLoading(true);
    const updated = {
      projectId: filterState?.selectedprojectId,
      from: newStartDate ? moment(newStartDate).format("YYYY-MM-DD") : "",
      to: newEndDate ? moment(newEndDate).format("YYYY-MM-DD") : "",
    };
    setState((prev) => ({
      ...prev,
      ...updated,
    }));

    fetchData(updated);
  };

  const resetFilters = async () => {
    setSelectedProject("");
    setRefreshLoading(true);
    const params = {
      projectId: "",
      from: "",
      to: "",
    };
    fetchData(params, 1);

    setFilterState((prev) => ({
      ...prev,
      selectedprojectId: "",
      dateRange: [null, null],
    }));

    setState(() => ({
      projectId: "",
      from: "",
      to: "",
    }));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setTableLoading(true);
    getCampaigns(state, page);
  };

  const handleDateChange = (updated) => {
    setFilterState((prev) => ({
      ...prev,
      dateRange: updated,
    }));
  };

  const { totalCost, balance, remainingMinutes, onHoldBalance } = dashboardData;

  const summaryCards = [
    {
      title: "Account Balance",
      circleColor:
        "linear-gradient(180deg, rgba(22, 200, 199, 0.8) 0%, rgba(106, 233, 233, 0.8) 100%)",
      value: selectedAccount?.params?.pricesWaivers ? (
        "--"
      ) : balance ? (
        `${showCurr ? "₹" : "$"} ${balance}`
      ) : (
        <LoadingDots />
      ),
      errorMessage: selectedAccount?.balanceExpired,
      expiryTime: selectedAccount?.balanceExpiryTime || 0,
      topupButtonShow:
        isVodexLoggedin() && isAdmin(selectedAccount, userDetails),
    },
    {
      title: "Consumed Cost",
      circleColor: "linear-gradient(268.11deg, #FFDA8F 9.11%, #EEB644 105.62%)",
      value: selectedAccount?.params?.pricesWaivers ? (
        "--"
      ) : totalCost ? (
        `${showCurr ? "₹" : "$"} ${totalCost}`
      ) : (
        <LoadingDots />
      ),
    },
    {
      title: "Remaining Mins",
      circleColor: "linear-gradient(60.26deg, #79EE81 15.53%, #26C231 89.39%)",
      value: selectedAccount?.params?.pricesWaivers ? "--" : remainingMinutes,
    },
    {
      title: "On Hold Balance",
      circleColor: "linear-gradient(180deg, #8FA8FF 0%, #4265E2 100%)",
      value: selectedAccount?.params?.pricesWaivers ? (
        "--"
      ) : onHoldBalance ? (
        `${showCurr ? "₹" : "$"} ${onHoldBalance}`
      ) : (
        <LoadingDots />
      ),
    },
  ];

  return (
    <Box sx={{ height: 100, position: "relative" }}>
      {window?.location?.origin === "https://app.voizer.ai" && (
        <VideoComponentCustom />
      )}
      {loading ? (
        <Box sx={styles.loadingContainer}>
          <PageLoader />
        </Box>
      ) : (
        <Box className="py-1">
          <Heading
            projectList={projectList}
            filterState={filterState}
            resetFilters={resetFilters}
            applyFilters={applyFilters}
            refreshLoading={refreshLoading}
            refreshData={refreshData}
            handleDateChange={handleDateChange}
            selectedProject={selectedProject}
            setSelectedProject={setSelectedProject}
          />
          <Grid container spacing={2} sx={{ my: 2 }}>
            <Grid size={{ xs: 12, md: 8 }}>
              <Grid container spacing={2}>
                {summaryCards?.map(
                  (
                    {
                      title,
                      circleColor,
                      value,
                      errorMessage,
                      expiryTime,
                      topupButtonShow,
                    }: any,
                    index
                  ) => (
                    <Grid size={{ xs: 12, md: 3 }} key={index}>
                      {" "}
                      <SummaryCard
                        title={title}
                        circleColor={circleColor}
                        value={value}
                        errorMessage={errorMessage}
                        expiryTime={expiryTime}
                        topupButtonShow={topupButtonShow}
                      />{" "}
                    </Grid>
                  )
                )}
                <Grid size={12}>
                  <BarChart chartData={chartData} state={state} />
                </Grid>
              </Grid>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <DoughnutChart chartData={dashboardData} />
            </Grid>
          </Grid>

          <CampaignList
            lastCampaignListData={lastCampaignListData}
            totalCampaigns={totalCampaignsCount}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
            tableLoading={tableLoading}
          />
        </Box>
      )}
      {isVodexLoggedin() && (
        <div style={{ zIndex: 100 }} className="floating-widget">
          {/* Widget content */}
          <i
            className="fab fa-discord"
            title="Connect with us on discord"
            onClick={() =>
              window.open(
                "https://discord.com/channels/1139884697221070848/1139885671713095740",
                "_blank"
              )
            }
          ></i>{" "}
        </div>
      )}
      {/* {isVodexLoggedin() && (
        <div className="floating-widget-youtube">
          <i
            className="fab fa-youtube"
            onClick={() =>
              window.open(
                "https://www.youtube.com/watch?v=4nSIwHPJlTs&list=PLN4jqjD9BdXxOqx7Ex0S6doiwdooGfwAK",
                "_blank"
              )
            }
          ></i>{" "}
        </div>
      )} */}
    </Box>
  );
};

export default DashboardHome;

const styles = {
  loadingContainer: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
  },
};
